import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_dashboard/layout/core';
import { ReservationsListWrapper } from './reservation-list/ReservationList';
import { useIntl } from 'react-intl';

const ReservationPage = () => {
  const intl = useIntl(); 
  const reservationsBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'RESERVATION_PAGE.BREADCRUMB' }), 
      path: '/apps/reservation-management/reservations',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='reservations'
          element={
            <>
              <PageTitle breadcrumbs={reservationsBreadcrumbs}>
                {intl.formatMessage({ id: 'RESERVATION_PAGE.TITLE' })}
              </PageTitle>
              <ReservationsListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/reservation-management/reservations' />} />
    </Routes>
  );
};

export default ReservationPage;